import React, { Children } from 'react';
import { motion } from 'framer-motion';
interface StarRatingProps {
  rating: number;
  className?: string;
  starSize?: number;
}
export function StarRating({
  rating,
  className = '',
  starSize = 20
}: StarRatingProps) {
  const fullStars = Math.floor(rating);
  const hasHalfStar = rating % 1 !== 0;
  const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const starVariants = {
    hidden: {
      opacity: 0,
      scale: 0.5,
      rotate: -30
    },
    visible: {
      opacity: 1,
      scale: 1,
      rotate: 0,
      transition: {
        type: 'spring',
        stiffness: 300,
        damping: 20
      }
    }
  };
  const StarIcon = ({
    type
  }: {
    type: 'full' | 'half' | 'empty';
  }) => {
    return <motion.div variants={starVariants} className="relative inline-block" style={{
      width: starSize,
      height: starSize
    }} data-id="element-145">
        <svg viewBox="0 0 24 24" className="w-full h-full text-gameu-star" fill={type === 'empty' ? 'none' : 'currentColor'} stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-146">
          {type === 'half' ? <>
              <defs data-id="element-147">
                <clipPath id="half-star" data-id="element-148">
                  <rect x="0" y="0" width="12" height="24" data-id="element-149" />
                </clipPath>
              </defs>
              <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" fill="none" data-id="element-150" />
              <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" clipPath="url(#half-star)" fill="currentColor" data-id="element-151" />
            </> : <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" data-id="element-152" />}
        </svg>
      </motion.div>;
  };
  return <motion.div className={`flex items-center gap-1 ${className}`} variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
    once: true,
    margin: '-50px'
  }} data-id="element-153">
      {[...Array(fullStars)].map((_, i) => <StarIcon key={`full-${i}`} type="full" data-id="element-154" />)}
      {hasHalfStar && <StarIcon type="half" data-id="element-155" />}
      {[...Array(emptyStars)].map((_, i) => <StarIcon key={`empty-${i}`} type="empty" data-id="element-156" />)}
    </motion.div>;
}